import classes from "./industry-four-table.module.scss";
import Flex from "@/components-library/layout/flex";
import Label from "@/components-library/widgets/label";
import classNames from "classnames";
import Grid from "@/components-library/layout/grid";
function IndustryFourTable() {
  return (
    <Flex
      align="flex-start"
      direction="column"
      justify="flex-start"
      className={classes.table}
    >
      <Grid columnGap={"2px"} columns="1fr 1fr 1fr" className={classes.header}>
        <Label
          tag="p"
          size="md"
          color="default"
          align="start"
          weight="bold"
          className={classNames(classes.firstColumn, classes.item)}
        >
          Investimenti
        </Label>
        <Label
          tag="p"
          size="md"
          color="default"
          align="start"
          weight="bold"
          className={classNames(classes.secondColumn, classes.item)}
        >
          Anno 2022
        </Label>
        <Label
          tag="p"
          size="md"
          color="default"
          align="start"
          weight="bold"
          className={classNames(classes.thirdColumn, classes.item)}
        >
          Dal 2023 al 2025
        </Label>
      </Grid>
      <Grid columnGap={"2px"} columns="1fr 1fr 1fr" className={classes.row}>
        <Label
          tag="p"
          size="md"
          color="secondary"
          align="start"
          weight="bold"
          className={classNames(classes.firstColumn, classes.item)}
        >
          Beni materiali 4.0 (Allegato A, legge n. 232/2016)
        </Label>

        <Label
          tag="p"
          size="md"
          color="secondary"
          align="start"
          weight="bold"
          className={classNames(classes.secondColumn, classes.item)}
        >
          {
            "40% per investimenti fino a 2,5 milioni\n20% per investimenti tra 2,5 e 10 milioni €\n10% per investimenti compresi tra 10 e 20 milioni €"
          }
        </Label>
        <Label
          tag="p"
          size="md"
          color="secondary"
          align="start"
          weight="bold"
          className={classNames(classes.thirdColumn, classes.item)}
        >
          {
            "20% per investimenti fino a 2,5 milioni\n10% per investimenti tra 2,5 e 10 milioni €\n5% per investimenti compresi tra 10 e 20 milioni €"
          }
        </Label>
      </Grid>
      <Grid columnGap={"2px"} columns="1fr 1fr 1fr" className={classes.row}>
        <Label
          tag="p"
          size="md"
          color="secondary"
          align="start"
          weight="bold"
          className={classNames(classes.firstColumn, classes.item)}
        >
          Beni immateriali 4.0 (Allegato B, legge n. 232/2016)
        </Label>

        <Label
          tag="p"
          size="md"
          color="secondary"
          align="start"
          weight="bold"
          className={classNames(classes.secondColumn, classes.item)}
        >
          {"20% per investimenti fino a 1 milione €"}
        </Label>
        <Label
          tag="p"
          size="md"
          color="secondary"
          align="start"
          weight="bold"
          className={classNames(classes.thirdColumn, classes.item)}
        >
          {
            "2023: 20% per investimenti fino a 1 milione €\n2024: 15% per investimenti fino a 1 milione €\n2025: Nessun credito"
          }
        </Label>
      </Grid>
    </Flex>
  );
}

export default IndustryFourTable;
